import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import ShippingProviderForm from "@components/forms/ShippingProviderForm";

const ShippingProviderAddEdit = () => {
  const params = useParams()
  const { id: shippingProviderId } = params;

  return (
    <PageContainer
      title={`${!shippingProviderId ? 'Agregar' : 'Editar'} Proveedor de Envio`}
      backUrl="/user/shipping-providers"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "shippingProviderForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ShippingProviderForm
        formId="shippingProviderForm"
        id={shippingProviderId}
        saveRedirectUrl="/user/shipping-providers"
      ></ShippingProviderForm>

    </PageContainer>
  );
}

export default ShippingProviderAddEdit;
